import React, { useState } from "react";
import Login from "../../components/user/Login/login";
import SignUp from "../../components/user/Signup/SignUp";
import * as S from "./styles"; // Import your styles from the separate styles.ts file

const CombinedLoginPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleForm = () => {
    setIsLogin(!isLogin);
  };

  return (
    <S.PageContainer> {/* Use your styled component for the container */}
      <h1>{isLogin ? "Login Page" : "Sign Up Page"}</h1>
      {isLogin ? (
        <Login />
      ) : (
        <SignUp />
      )}
      <S.ButtonContainer> {/* Use your styled component for the button container */}
        <button onClick={toggleForm}>
          {isLogin ? "Switch to Sign Up" : "Switch to Login"}
        </button>
      </S.ButtonContainer>
    </S.PageContainer>
  );
};

export default CombinedLoginPage;
